export default function isEmpty(str) {
  if (str === null) {
    return undefined;
  }

  return str !== '';
}
